module.exports = __webpack_public_path__ + "24ba9b51e68d08fd6afe12a4b5f3f054.svg";